import { gql } from "@apollo/client"

/**
 * Registration, and the two links that arrive by email.
 *
 * All four are callable with no session — the caller either has no account yet
 * or cannot reach the one they have. Each is bounded on the server: a single-use
 * token with a deadline, a throttle, and (for the two that take only an address)
 * an answer that does not vary with whether that address is known, so neither
 * form can be used to ask which addresses have accounts here.
 */

export const REGISTER_WITH_EMAIL = gql`
  mutation RegisterWithEmail(
    $name: String!
    $email: String!
    $password: String!
    $role: String!
    $birthDate: String
    $acceptsTerms: Boolean
  ) {
    registerWithEmail(
      name: $name
      email: $email
      password: $password
      role: $role
      birthDate: $birthDate
      acceptsTerms: $acceptsTerms
    ) {
      success
      # Whether the mail actually left. The account exists either way, so a false
      # here has to be said out loud — otherwise somebody waits for a link that
      # was never sent.
      emailed
      errors
    }
  }
`

export const RESEND_CONFIRMATION = gql`
  mutation ResendConfirmation($email: String!) {
    resendConfirmation(email: $email) {
      success
    }
  }
`

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      success
      error
    }
  }
`
